export const COMPANY = {
  name: 'VAJ Prakruti Homes (OPC) Pvt. Ltd.',
  shortName: 'Prakruti Homes',
  descriptor: 'Developer',
  owner: 'Rajasekhar Reddy',
  phone: '+91 70508 12347',
  phoneRaw: '7050812347',
  email: 'prakrutihomers@gmail.com',
  address: '1st Floor, Kille Bruhanmatha Complex, Opp. EK Minar Masjid, Androon Quilla, Raichur, Karnataka 584101',
  hours: '10:00 AM – 7:00 PM',
  tagline: 'Your Trust. Our Commitment. A Better Future.',
  blurb: 'Developer — real estate, construction and building material supply under one roof. Build today, sustain tomorrow.',
};

export const PROJECTS = [
  {
    id: 'prakruti-enclave',
    name: 'Prakruti Enclave',
    location: 'Potgal',
    category: 'Plots',
    status: 'Completed',
    approval: 'NA Approved · RUDA',
    tagline: 'Premium plots in a green, gated setting — ready for construction.',
    price: 'With EMI facility',
    image: '/assets/projects/prakruti-enclave/1.png',
    gallery: ['/assets/projects/meadows-1.jpg', '/assets/projects/meadows-2.jpg', '/assets/projects/meadows-3.jpg', '/assets/projects/meadows-4.jpg'],
    amenities: ['Underground Drainage Lines', 'Jogging Tracks', 'Avenue Plantations', 'Underground Electric Supply', 'Park & Landscape Garden', 'Street Lights', 'Water Connection to Every Plot', 'Temple', 'CC Roads', 'Gated Community', 'Compound Wall'],
    highlights: ['5 min to Potgal Bus Stand', '5 min to SLN Govt College', '5 min to IIM', '5 min to Irrigation Dept', '10 min to Shilpa Medicare', '10 min to Rajiv Gandhi Hospital', '10 min to RMS Govt Hospital', '15 min to Gunj Cricket Ground'],
    mapUrl: 'https://maps.app.goo.gl/ruAuEfk6JFmTMLFq8',
    mapEmbed: 'https://www.google.com/maps?q=16.2477638,77.3776486&z=16&output=embed',
    flyer: '/assets/flyers/prakruti-enclave-flyer.pdf',
  },
  {
    id: 'prakruti-meadows',
    name: 'Prakruti Meadows',
    location: 'Yegnur',
    category: 'Plots',
    status: 'Ongoing',
    approval: 'NA & RDA Proposed',
    tagline: '100% Vaastu-compliant gated community plots, minutes from the airport.',
    price: 'With EMI facility',
    image: '/assets/projects/prakruti-upcoming/1.png',
    // image: '/assets/projects/meadows-1.jpg',
    gallery: ['/assets/projects/Prakruti-Sunrise/1.jpeg', '/assets/projects/Prakruti-Sunrise/2.jpeg', '/assets/projects/Prakruti-Sunrise/3.jpeg', '/assets/projects/Prakruti-Sunrise/4.jpeg'],
    amenities: ['30 ft Wide BT Roads', 'Sewage Treatment Plant', 'Street Lights & Electrical Line', 'Garden with Walking Track', 'UGD Connection to Each Plot', 'Water Supply to Each Plot', 'Clean Drainage System', 'Avenue Plantation', 'Park', 'C.A. Site', 'Compound Wall', 'Gated Community'],
    highlights: ['2 km to Airport', '1 km to KDBI', 'Attached to Karnataka Housing Board', '100 m to Proposed Ring Road', '3 km to Hyderabad Road', '3.3 km to City Bypass', '3 km to IIIT', '3 km to SLN Engineering College'],
    mapUrl: 'https://maps.app.goo.gl/iDntVMXPzq6hzRNUA',
    mapEmbed: 'https://www.google.com/maps?q=16.273343,77.372614&z=16&output=embed',
    flyer: '/assets/flyers/prakruti-meadows-flyer.pdf',
  },
  {
    id: 'prakruti-green',
    name: 'Prakruti Green',
    location: 'Chandrabanda Road',
    category: 'Plots',
    status: 'Ongoing',
    approval: 'NA & RDA Proposed',
    tagline: 'Gated Vaastu plots tucked off Chandrabanda Road, near the proposed Ring Road.',
    price: 'Book at ₹1 Lakh · With EMI facility',
    image: '/assets/projects/prakruti-upcoming/1.png',
    // image: '/assets/projects/prakruti-green/1.png',
    gallery: ['/assets/projects/Prakruti-Sunrise/1.jpeg', '/assets/projects/Prakruti-Sunrise/2.jpeg', '/assets/projects/Prakruti-Sunrise/3.jpeg', '/assets/projects/Prakruti-Sunrise/4.jpeg'],
    amenities: ['30 ft Wide BT Roads', 'Sewage Treatment Plant', 'Street Lights & Electrical Line', 'Garden with Walking Track', 'Avenue Plantation', 'UGD Connection to Each Plot', 'Water Supply to Each Plot', 'Clean Drainage System', 'Water Tank', 'Compound Wall', 'Gated Community'],
    highlights: ['2 min to Proposed Ring Road', '5 min to LBS Nagar', '10 min to Hyderabad Road', '10 min to Ganj', '10 min to New District Court', '15 min to City Bus Stand'],
    mapUrl: 'https://maps.app.goo.gl/szNv8tvwJd1sXGuE6',
    mapEmbed: 'https://www.google.com/maps?q=16.2205,77.3973141&z=16&output=embed',
    flyer: '/assets/flyers/prakruti-green-flyer.pdf',
  },
  {
    id: 'prakruti-upcoming',
    name: 'Prakruti Sunrise',
    location: 'To be announced',
    category: 'Plots',
    status: 'Upcoming',
    approval: 'NA & RDA Proposed',
    tagline: 'Our fourth layout, Prakruti Sunrise, is currently under development. Full details, photos and flyer will be announced shortly — register your interest early.',
    price: 'With EMI facility',
    image: '/assets/projects/Prakruti-Sunrise/5.png',
    gallery: [],
    amenities: [],
    highlights: [],
    mapUrl: 'https://maps.app.goo.gl/Wb72zgV1sWF1q5Yc8',
    mapEmbed: 'https://www.google.com/maps?q=16.227095,77.378656&z=16&output=embed',
    flyer: null,
  },
];

export const SERVICES = [
  { num: '01', title: 'Plotting Development', desc: 'NA & RDA approved gated layouts with BT roads, UGD, parks and avenue plantations.' },
  { num: '02', title: 'Apartment Development', desc: 'Well-ventilated apartment communities designed around light, air and green space.' },
  { num: '03', title: 'Villa Development', desc: 'Private villas with courtyards, green roofs and honest, earthy materials.' },
  { num: '04', title: 'Interior Design', desc: 'Warm minimal interiors — clay, timber, cane and stone in quiet dialogue.' },
  { num: '05', title: 'Building Materials', desc: 'Cement, steel, bricks, aggregates and finishing materials — quality assured, fair priced.' },
  { num: '06', title: 'Government Contracts', desc: 'Compliant, on-time execution of public infrastructure and institutional works.' },
];

export const SERVICES_DETAIL = [
  {
    num: '01', title: 'Plotting Development', type: 'Plot', cta: 'ENQUIRE ABOUT PLOTS',
    image: '/assets/projects/meadows-2.jpg',
    desc: 'NA & RDA approved gated community layouts — clear titles, full infrastructure and plots ready for construction.',
    benefits: ['NA approved & RDA proposed titles', '30 ft BT roads with street lights', 'UGD, water & power to every plot', 'With EMI facility'],
  },
  {
    num: '02', title: 'Apartment Development', type: 'Apartment', cta: 'ENQUIRE ABOUT APARTMENTS',
    image: 'https://images.unsplash.com/photo-1667510436110-79d3dabc2008?auto=format&fit=crop&w=1200&q=80',
    desc: 'Well-ventilated apartment communities designed around light, air and green space — built with the same discipline as our layouts.',
    benefits: ['Vaastu-compliant unit planning', 'Cross-ventilation & daylight design', 'Quality-certified materials throughout', 'Transparent milestone tracking'],
  },
  {
    num: '03', title: 'Villa Development', type: 'Villa', cta: 'ENQUIRE ABOUT VILLAS',
    image: 'https://images.pexels.com/photos/5435079/pexels-photo-5435079.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    desc: 'Private villas with courtyards, deep overhangs and honest materials — designed for the Deccan climate, built to outlive trends.',
    benefits: ['Custom designs per family', 'Courtyards & green roofs', 'Solar-ready structures', 'Single-point project management'],
  },
  {
    num: '04', title: 'Interior Design', type: 'Interior', cta: 'ENQUIRE ABOUT INTERIORS',
    image: 'https://images.unsplash.com/photo-1608303588026-884930af2559?auto=format&fit=crop&w=1200&q=80',
    desc: 'Warm, minimal interiors in clay, timber, cane and stone — spaces that feel crafted, not assembled.',
    benefits: ['3D designs before execution', 'Low-VOC, durable finishes', 'Modular & custom carpentry', 'Handover-ready deep clean'],
  },
  {
    num: '05', title: 'Building Materials', type: 'Building Materials', cta: 'ENQUIRE ABOUT MATERIALS',
    image: 'https://images.pexels.com/photos/5582590/pexels-photo-5582590.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    desc: 'Cement, steel, bricks, blocks, aggregates and finishing materials supplied directly — the same stock we build with ourselves.',
    benefits: ['Certified brands only', 'Site-delivered on schedule', 'Contractor & bulk pricing', 'Quality checked at dispatch'],
  },
  {
    num: '06', title: 'Government Contracts', type: 'Government Contract', cta: 'ENQUIRE ABOUT CONTRACTS',
    image: 'https://images.unsplash.com/photo-1646987916641-1f3c8992daa2?auto=format&fit=crop&w=1200&q=80',
    desc: 'Compliant, on-time execution of public infrastructure and institutional works — documentation, rates and timelines by the book.',
    benefits: ['Tender-compliant execution', 'Institutional & public works', 'Scheduled progress reporting', 'Safety-first site practices'],
  },
];

export const TESTIMONIALS = [
  {
    quote: 'We visited three layouts before choosing Enclave. Only Prakruti showed us the NA order and EC without being asked. The CC roads and plantation are exactly as promised.',
    name: 'Plot Owner',
    role: 'Prakruti Enclave, Potgal',
    image: '/assets/projects/potgal-2.jpg',
  },
  {
    quote: 'Booked at ₹1 lakh with the EMI facility. Site visit, agreement and registration were all handled from their office — no brokers, no hidden charges.',
    name: 'Plot Owner',
    role: 'Prakruti Meadows, Yegnur',
    image: '/assets/projects/meadows-2.jpg',
  },
  {
    quote: 'They supply our cement and steel for the same sites they develop. One accountable team for land, material and construction — rare among developers.',
    name: 'Contractor Partner',
    role: 'Building Materials Division',
    image: '/assets/projects/green-3.jpg',
  },
];

export const WHY_US = [
  { num: '01', icon: 'ShieldCheck', title: 'Trusted Brand', desc: 'Reliable and transparent property solutions.' },
  { num: '02', icon: 'MapPin', title: 'Prime Locations', desc: 'Projects selected for strong connectivity and future growth.' },
  { num: '03', icon: 'FileCheck', title: 'Approved Layouts', desc: 'Focus on legally compliant and approved developments.' },
  { num: '04', icon: 'Route', title: 'Quality Infrastructure', desc: 'Well-planned roads, drainage, electricity, water supply and street lighting.' },
  { num: '05', icon: 'Trees', title: 'Modern Amenities', desc: 'Parks, open spaces and thoughtfully planned community facilities.' },
  { num: '06', icon: 'TrendingUp', title: 'Smart Investment', desc: 'Properties designed for long-term appreciation and value.' },
  { num: '07', icon: 'Handshake', title: 'Transparent Transactions', desc: 'Clear documentation, honest pricing and professional service.' },
  { num: '08', icon: 'HardHat', title: 'Quality Construction & Development', desc: 'Attention to quality, durability and timely execution.' },
  { num: '09', icon: 'Users', title: 'Customer-Focused Service', desc: 'Dedicated support from site visit to registration and beyond.' },
];

export const JOBS = [
  { id: 'civil-site-engineer', title: 'Civil Site Engineer', type: 'Full-time', location: 'Multiple Sites', desc: 'Manage layout development works — roads, drainage, compound walls — across our Yegnur and Chandrabanda sites. 2+ years in plotted development or civil contracting.' },
  { id: 'sales-executive-plots', title: 'Sales Executive — Plots', type: 'Full-time', location: 'Head Office', desc: 'Guide plot buyers from first call to registration. Site visit coordination, EMI plan explanation and documentation support. Two-wheeler and local knowledge preferred.' },
  { id: 'site-supervisor', title: 'Site Supervisor', type: 'Full-time', location: 'Yegnur / Chandrabanda', desc: 'Day-to-day supervision of avenue plantation, street lighting and UGD works. ITI/Diploma with 1+ years of site experience.' },
  { id: 'solar-technician', title: 'Solar Installation Technician', type: 'Upcoming Division', location: 'Head Office', desc: 'Join our renewable energy team at launch — rooftop solar installation and maintenance. Electrical background; solar experience a plus, training provided.' },
];

export const POSTS = [
  {
    slug: 'plot-buying-checklist-raichur',
    title: '10 Things to Check Before Buying a Plot',
    category: 'Plot Guide',
    date: '18 Jul 2026',
    read: '6 min',
    image: '/assets/projects/potgal-2.jpg',
    excerpt: 'Title clarity, approvals, road widths, water lines — the exact checklist our team uses before we recommend any layout to a buyer.',
    body: [
      'Buying a plot is likely the largest cheque your family will write this decade. With new layouts appearing every quarter, the difference between a good plot and a legal headache comes down to ten checks.',
      'First, verify the title chain — ask for the mother deed and at least 30 years of encumbrance certificate. Second, confirm the conversion status: agricultural land must be NA (non-agricultural) converted before it can legally host a residential layout.',
      'Third and fourth, check the approving authority and the layout plan number. A RUDA or RDA reference should be printed on the sanctioned plan you are shown — not just spoken about. Fifth, walk the roads: sanctioned layouts specify road widths, and 30 ft or wider internal roads hold value far better.',
      'Sixth through eighth, ask about water, drainage and power. At Prakruti layouts we run underground drainage, individual water connections and underground electric supply to every plot — insist on seeing these on site, not in a brochure.',
      'Ninth, check what surrounds the layout: schools, hospitals, ring road proposals. Tenth, meet an existing plot owner in the project if it is partly sold. Ten minutes of honest conversation beats ten brochures. Do these ten checks and you will buy with confidence.',
    ],
  },
  {
    slug: 'na-approval-explained',
    title: 'NA Approval Explained: What It Means for Your Plot',
    category: 'Legal',
    date: '9 Jul 2026',
    read: '5 min',
    image: '/assets/projects/meadows-3.jpg',
    excerpt: 'Why NA conversion is the single most important document in plotted development — and how to verify it in fifteen minutes.',
    body: [
      'NA stands for Non-Agricultural. In Karnataka, land is agricultural by default, and it cannot legally be used for housing layouts until the District Collector converts it through an NA order.',
      'Why does this matter to you as a buyer? A plot on unconverted agricultural land cannot get a khata in your name, cannot easily get a building plan sanctioned, and banks will refuse loans against it. Resale becomes painful.',
      'Verifying NA status is straightforward. Ask the developer for the NA order copy — it carries an order number, survey number and date. Cross-check the survey number against the plot you are being shown, because an order for one survey number does not cover the neighbouring one.',
      'At Prakruti, our Enclave layout is NA approved, and our Meadows and Green layouts are NA & RDA proposed with documentation available for inspection at our office. We encourage every buyer to verify — a developer confident in their papers will never hesitate to show them.',
    ],
  },
  {
    slug: 'rda-proposed-vs-approved',
    title: 'RDA Proposed vs RDA Approved: Know the Difference',
    category: 'Legal',
    date: '28 Jun 2026',
    read: '4 min',
    image: '/assets/projects/green-2.jpg',
    excerpt: 'Two words that change your risk profile completely. Here is how to read them in any layout advertisement.',
    body: [
      'You will see both phrases on hoardings across the region. "RDA Approved" means the development authority has sanctioned the layout plan — roads, parks, civic amenity sites and all. "RDA Proposed" means the application is in process and approval is expected, but not yet granted.',
      'Is a proposed layout a bad buy? Not automatically — but it should be priced accordingly, and the developer should be transparent about the stage of the application, with a copy of the submission acknowledgement available.',
      'Protect yourself three ways: see the application acknowledgement, understand that possession timelines depend on approval, and ensure your sale agreement mentions the approval status explicitly.',
      'We label our own projects honestly — Prakruti Enclave carries NA approval with RUDA reference, while Meadows and Green are clearly marked NA & RDA Proposed. Ask us the difference in person; we will show you both file sets.',
    ],
  },
  {
    slug: 'raichur-growth-story',
    title: 'Why North Karnataka Is the Next Growth Story',
    category: 'Market',
    date: '15 Jun 2026',
    read: '6 min',
    image: '/assets/projects/meadows-1.jpg',
    excerpt: 'An airport, IIIT, IIM proximity, a proposed ring road and industrial corridors — the fundamentals behind the region\u2019s land story.',
    body: [
      'Every land market has a moment when infrastructure, education and industry align. For North Karnataka, that alignment is happening now.',
      'The operational airport has cut travel time to Hyderabad and Bengaluru dramatically. IIIT and the proposed IIM campus are bringing thousands of students and faculty — and every one of them needs housing within a 5 km radius.',
      'The proposed Ring Road will unlock the city\u2019s outer belt, exactly where our Yegnur and Chandrabanda Road layouts sit. Industrial expansion and the Karnataka Housing Board\u2019s projects add employment and civic investment to the same corridor.',
      'Historically, plotted land near education and airport infrastructure in tier-2 Karnataka cities has appreciated steadily rather than spectacularly — which is precisely what a family investor should want. We build here because we believe this story is just beginning.',
    ],
  },
  {
    slug: 'emi-vs-full-payment-plot',
    title: 'EMI vs Full Payment: Smart Ways to Own Your Plot',
    category: 'Finance',
    date: '2 Jun 2026',
    read: '5 min',
    image: '/assets/projects/potgal-3.jpg',
    excerpt: 'Book at ₹1 lakh and pay monthly, or close in one go? A practical comparison for salaried families.',
    body: [
      'The most common question at our office: should I pay for my plot in full, or take the EMI route? The honest answer depends on three things — your cash reserves, your monthly surplus, and what the money would do otherwise.',
      'Full payment wins when you have idle savings earning little, and when the developer offers a meaningful upfront discount. You also skip interest entirely and get registration done immediately.',
      'EMI wins when liquid cash matters more to you than total cost — a government employee or salaried professional with a modest monthly surplus can own a plot at Prakruti Meadows or Green today with a ₹1 lakh booking, instead of waiting years to accumulate the full amount while prices move.',
      'A middle path many of our buyers choose: book on EMI, then pre-close with a bonus or harvest income. Whatever you choose, get the payment schedule in writing in your agreement. Ours is printed on the first page.',
    ],
  },
  {
    slug: 'vaastu-plots-what-matters',
    title: 'Vaastu-Compliant Plots: What Actually Matters',
    category: 'Design',
    date: '20 May 2026',
    read: '4 min',
    image: '/assets/projects/green-4.jpg',
    excerpt: 'Orientation, road position, plot shape — separating genuine Vaastu value from marketing noise.',
    body: [
      'Every layout in Karnataka claims Vaastu compliance. Few explain what it means. For plots, three factors carry most of the weight.',
      'Orientation comes first. East and north-facing plots are preferred because they receive morning light and allow the home\u2019s main door and living spaces to be positioned favourably without design compromises.',
      'Plot shape comes second. Square and rectangular plots with clean boundaries — what Vaastu calls Shermukhi and Gaumukhi forms — are easier to design on and easier to resell. Irregular cuts at corners should make you ask why.',
      'Road position matters third: a plot with roads on the north or east is traditionally valued higher. At Prakruti, every plot in our Meadows and Green layouts is planned 100% Vaastu compliant at the layout stage itself — orientation, shape and road position decided before the first boundary stone was laid. Ask our team for the Vaastu map when you visit.',
    ],
  },
];

export const GALLERY_IMAGES = [
  { src: '/assets/projects/potgal-1.jpg', caption: 'Avenue plantation — Prakruti Enclave, Potgal' },
  { src: '/assets/projects/meadows-1.jpg', caption: 'Entrance arch — Prakruti Meadows, Yegnur' },
  { src: '/assets/projects/green-1.jpg', caption: 'Grand entrance gate — Prakruti Green, Chandrabanda Road' },
  { src: '/assets/projects/potgal-2.jpg', caption: 'Internal CC road — Prakruti Enclave' },
  { src: '/assets/projects/meadows-2.jpg', caption: 'BT road with street lights — Meadows' },
  { src: '/assets/projects/green-2.jpg', caption: 'Compound wall & fencing — Prakruti Green' },
  { src: '/assets/projects/potgal-3.jpg', caption: 'Tree-lined stretch — Prakruti Enclave' },
  { src: '/assets/projects/meadows-3.jpg', caption: 'Layout main road — Meadows' },
  { src: '/assets/projects/green-3.jpg', caption: 'Layout boundary — Prakruti Green' },
  { src: '/assets/projects/potgal-4.jpg', caption: 'Curved CC road — Prakruti Enclave' },
  { src: '/assets/projects/meadows-4.jpg', caption: 'Plantation avenue — Meadows' },
  { src: '/assets/projects/green-4.jpg', caption: 'Entrance canopy — Prakruti Green' },
  { src: '/assets/gallery/site-1.jpg', caption: 'Street lights & saplings — on site' },
  { src: '/assets/projects/prakruti-upcoming/1.png', caption: 'Compound wall painting — Prakruti Sunrise' },
  { src: '/assets/projects/prakruti-upcoming/2.png', caption: 'Boundary works in progress — Prakruti Sunrise' },
  { src: '/assets/projects/prakruti-upcoming/3.png', caption: 'Branded compound wall — Prakruti Sunrise' },
  { src: '/assets/social/1.jpg', caption: 'Annadana seva — CSR Activities' },
  { src: '/assets/social/2.jpg', caption: 'Monthly food donation drive — CSR Activities' },
  { src: '/assets/social/3.jpg', caption: 'Addressing the gathering — CSR Activities' },
  { src: '/assets/social/5.jpg', caption: 'With the Charitable Trust — CSR Activities' },
  { src: '/assets/social/6.jpg', caption: 'Felicitation at Annadana — CSR Activities' },
];

export const SOCIAL = {
  partner: 'Dr. Puneeth Rajkumar Charitable Trust',
  activity: 'Annadana — monthly food donation drives',
  images: [
    { src: '/assets/social/1.jpg', caption: 'Annadana seva — volunteers serving lunch' },
    { src: '/assets/social/2.jpg', caption: 'Monthly food donation drive' },
    { src: '/assets/social/3.jpg', caption: 'Addressing the gathering' },
    { src: '/assets/social/4.jpg', caption: 'Team Prakruti with community elders' },
    { src: '/assets/social/5.jpg', caption: 'Serving with the Charitable Trust' },
    { src: '/assets/social/6.jpg', caption: 'Felicitation at the Annadana program' },
    { src: '/assets/social/7.jpg', caption: 'Trust banner — Annadana Karyakrama' },
    { src: '/assets/social/8.jpg', caption: 'Volunteers honoured on stage' },
  ],
  videos: [
    { src: '/assets/social/video-1.mp4', poster: '/assets/social/poster-1.jpg', caption: 'Annadana drive — highlights' },
    { src: '/assets/social/video-2.mp4', poster: '/assets/social/poster-2.jpg', caption: 'Food donation program — full coverage' },
  ],
};

export const GALLERY_VIDEOS = [
  { src: '/assets/gallery/site-video.mp4', poster: '/assets/projects/meadows-2.jpg', caption: 'Site walkthrough — Prakruti layouts' },
  { src: '/assets/gallery/upcoming-video.mp4', poster: '/assets/projects/prakruti-upcoming/1.png', caption: 'Prakruti Sunrise — compound wall works' },
];

export const GALLERY_VIDEO = GALLERY_VIDEOS[0];

export const ENQUIRY_PROJECTS = [...PROJECTS.map((p) => p.name), 'Other / General'];

export const FORMSUBMIT_URL = 'https://formsubmit.co/ajax/prakrutihomers@gmail.com';
